import React from 'react';
import { withRouter } from 'react-router-dom';
import { Doughnut } from 'react-chartjs-2';
import moment from 'moment';
import { Grid } from './../../../../themes/default';
import { Legend } from './../../../../components/includes/ui';
import { CardDefault } from './../../../../components/includes/card';
import { Dropdown } from './../../../../components/includes/dropdown';
import { SnackbarStatic } from './../../../../components/includes/snackbar';
import { PollService } from './../../../../services';
import { getPercentaje } from './../../../../utilities/utils';
import ThemeCustom from './../../../../themes/custom';

class PollReport extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      report: null,
      dates: null,
      loading: false,
      error: false
    };
  }

  componentDidMount(){
    this._Find();
  }

  /*
  ** @Service
  ** @Description: Find log
  */

  _Find = () => {

    PollService.reportAll().then((response) => {

      this.setState({
        loading: true,
        report: response,
        dates: `${ moment(response.start).format('D MMMM, YYYY') } — ${ moment(response.end).format('D MMMM, YYYY') }`
      });

    }).catch((error) => {

      this.setState({ loading: true, error: true });

    });

  }

  /*
  ** @Event
  ** @Description: Redirect to list
  */

  handleRedirectToList = () => {

    this.props.history.push({
      pathname: `/polls`
    });

  }

  render() {

    const { loading, error, report, dates } = this.state;
    const legend = { display: false };

    const data = {
      options: {
        layout: {
            padding: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
            }
        }
      },
    	labels: [
    		'Completas',
    		'Abiertas',
    		'Inactivas'
    	],
    	datasets: [{
    		data: [
          this.state.report ? this.state.report.answered : 0,
          this.state.report ? this.state.report.opened : 0,
          this.state.report ? this.state.report.inactive : 0
        ],
    		backgroundColor: [
      		ThemeCustom.palette.success.main,
      		ThemeCustom.palette.warning.main,
      		ThemeCustom.palette.info.main
    		]
    	}]
    };

    return (
        loading && (
          <CardDefault
            title="Encuestas"
            subheader={ dates }
            action={
              <Dropdown items={
                  [
                    { label: 'Listado', event: () => { this.handleRedirectToList() } }
                  ]
                }
              />
            }
          >
            <Grid container spacing={8} justify="center" alignItems="center">

              { !error ? (
                <React.Fragment>
                  <Grid item lg={4} md={6} sm={12} xs={12}>
                    <Doughnut data={ data } legend={ legend }/>
                  </Grid>
                  <Grid item lg={8} md={6} sm={12} xs={12}>
                    { report && (
                      <React.Fragment>
                        <Legend
                          variant="success"
                          text={`${ getPercentaje(report.answered, report.total) }% Completas (${ report.answered })`}
                        />
                        <Legend
                          variant="warning"
                          text={`${ getPercentaje(report.opened, report.total) }% Abiertas (${ report.opened })`}
                        />
                        <Legend
                          variant="info"
                          text={`${ getPercentaje(report.inactive, report.total) }% Inactivas (${ report.inactive })`}
                          disableGutters
                        />
                      </React.Fragment>
                    )}
                  </Grid>
                </React.Fragment>
              ) : (
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <SnackbarStatic
                    icon="info"
                    variant="warning"
                    message="Hubo un error interno, por favor intenta más tarde."
                    open={true}
                    fullWidth hideClose/>
                </Grid>
              )}

            </Grid>
          </CardDefault>
        )
      )
    }

}

export default withRouter(PollReport);
